(function () {
  'use strict';

  var THRESHOLDS = { EUR: 0, USD: 0, GBP: 0, CAD: 0, AUD: 0, NZD: 0 };

  var syncFrame = 0;
  var upsellBusy = false;

  function rootUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.slice(-1) === '/' ? root : root + '/';
  }

  function drawer() {
    return document.querySelector('#cart-drawer, cart-drawer, [data-cart-drawer]');
  }

  function currencyCode() {
    var d = drawer();
    var button = d && d.querySelector('[data-ab-checkout-button]');
    var cfg = window.AubrielleRosewood || {};
    var active = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    var bar = d && d.querySelector('[data-ab-shipping-progress], .ab-shipping-progress');

    return String(
      (button && button.getAttribute('data-ab-currency')) ||
      cfg.currency ||
      active ||
      (bar && bar.getAttribute('data-currency')) ||
      'USD'
    ).toUpperCase();
  }

  function thresholdFor(currency) {
    var code = String(currency || 'USD').toUpperCase();
    return THRESHOLDS[code] || THRESHOLDS.USD;
  }

  function cartTotalCents() {
    var d = drawer();
    if (!d) return 0;

    var price = d.querySelector('[data-ab-checkout-price]');
    var cents = price && price.getAttribute('data-cents');
    if (cents !== null && cents !== undefined && cents !== '') {
      return Math.max(0, Number(cents) || 0);
    }

    var total = d.querySelector('[data-cart-total]');
    var totalCents = total && total.getAttribute('data-cart-total');
    if (totalCents !== null && totalCents !== undefined && totalCents !== '') {
      return Math.max(0, Number(totalCents) || 0);
    }

    var bar = d.querySelector('[data-ab-shipping-progress], .ab-shipping-progress');
    return Math.max(0, Number(bar && bar.getAttribute('data-total-cents')) || 0);
  }

  function formatMoney(cents, currency) {
    var code = String(currency || 'USD').toUpperCase();
    var value = Math.max(0, Number(cents) || 0) / 100;

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: code,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    } catch (error) {
      var amount = value.toFixed(2);
      if (code === 'EUR') return '€' + amount.replace('.', ',');
      if (code === 'GBP') return '£' + amount;
      if (code === 'CAD') return 'C$' + amount;
      if (code === 'AUD') return 'A$' + amount;
      if (code === 'NZD') return 'NZ$' + amount;
      if (code === 'USD') return '$' + amount;
      return amount + ' ' + code;
    }
  }

  function setText(node, text) {
    if (node && node.textContent !== text) node.textContent = text;
  }

  function setAttr(node, name, value) {
    if (!node) return;
    value = String(value);
    if (node.getAttribute(name) !== value) node.setAttribute(name, value);
  }

  function ensureShippingBar() {
    var d = drawer();
    if (!d) return null;

    d.querySelectorAll('.ab-shipping-progress--compat').forEach(function (node) {
      node.remove();
    });

    var bar = d.querySelector('[data-ab-shipping-progress]:not([data-items-holder]), .ab-shipping-progress:not(.ab-shipping-progress--compat)');
    if (bar) {
      bar.hidden = false;
      bar.removeAttribute('aria-hidden');
      bar.style.removeProperty('display');
      bar.setAttribute('data-ab-shipping-progress', '');
      return bar;
    }

    var head = d.querySelector('.drawer__head, .cart-block--top');
    if (!head) return null;

    bar = document.createElement('div');
    bar.className = 'ab-shipping-progress';
    bar.setAttribute('data-ab-shipping-progress', '');
    bar.setAttribute('role', 'status');
    bar.setAttribute('aria-live', 'polite');
    bar.innerHTML =
      '<div class="ab-shipping-progress__top">' +
        '<span class="ab-shipping-progress__text" data-ab-shipping-message></span>' +
        '<strong class="ab-shipping-progress__amount" data-ab-shipping-check hidden>✓</strong>' +
      '</div>' +
      '<div class="ab-shipping-progress__track" role="progressbar" aria-label="Free tracked shipping progress" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">' +
        '<span class="ab-shipping-progress__bar" data-ab-shipping-fill style="width:0%"></span>' +
      '</div>';

    head.insertAdjacentElement('afterend', bar);
    return bar;
  }

  function syncShippingBar() {
    var bar = ensureShippingBar();
    if (!bar) return;

    var currency = currencyCode();
    var total = cartTotalCents();
    var threshold = thresholdFor(currency);
    var remaining = Math.max(0, threshold - total);
    var progress = threshold > 0 ? Math.min(100, Math.max(0, total / threshold * 100)) : 100;

    var message = bar.querySelector('[data-ab-shipping-message], .ab-shipping-progress__text');
    var amount = bar.querySelector('[data-ab-shipping-check], .ab-shipping-progress__amount');
    var fill = bar.querySelector('[data-ab-shipping-fill], .ab-shipping-progress__bar');
    var track = bar.querySelector('[role="progressbar"]');

    setAttr(bar, 'data-currency', currency);
    setAttr(bar, 'data-total-cents', total);
    setAttr(bar, 'data-threshold-cents', threshold);

    if (remaining <= 0) {
      setText(message, 'Free shipping on every order');
      if (amount) {
        amount.hidden = false;
        setText(amount, '✓');
      }
    } else {
      setText(message, "You're " + formatMoney(remaining, currency) + ' away from free tracked shipping');
      if (amount) amount.hidden = true;
    }

    if (fill) {
      var width = progress.toFixed(2) + '%';
      if (fill.style.width !== width) fill.style.width = width;
    }
    setAttr(track, 'aria-valuenow', Math.round(progress));
  }

  function addBusinessDays(date, days) {
    var result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    var remaining = Math.max(0, Number(days) || 0);

    while (remaining > 0) {
      result.setDate(result.getDate() + 1);
      var weekday = result.getDay();
      if (weekday !== 0 && weekday !== 6) remaining -= 1;
    }

    return result;
  }

  function syncEta() {
    var eta = addBusinessDays(new Date(), 2);
    var formatted = eta.toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric'
    });

    document.querySelectorAll('[data-ab-eta-date]').forEach(function (node) {
      setText(node, formatted);
    });
  }

  function syncAll() {
    syncFrame = 0;
    syncShippingBar();
    syncEta();
  }

  function scheduleSync() {
    if (syncFrame) return;
    syncFrame = window.requestAnimationFrame(syncAll);
  }

  function refreshNativeCart() {
    return new Promise(function (resolve) {
      var finished = false;
      var timer = 0;

      function done() {
        if (finished) return;
        finished = true;
        document.removeEventListener('theme:cart:change', done);
        if (timer) window.clearTimeout(timer);
        scheduleSync();
        resolve();
      }

      document.addEventListener('theme:cart:change', done);
      timer = window.setTimeout(done, 3000);

      var cartItems = document.querySelector('cart-items');
      if (cartItems && typeof cartItems.getCart === 'function') {
        cartItems.getCart();
      } else {
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      }
    });
  }

  async function addUpsell(button) {
    if (!button || upsellBusy || button.dataset.abNativeAddBusy === '1') return;

    var card = button.closest('.ab-upsell-card');
    var select = card && card.querySelector('.ab-upsell-card__select');
    var variantId = Number(select && select.value);
    if (!variantId) return;

    var originalText = button.textContent || '+ ADD';
    upsellBusy = true;
    button.dataset.abNativeAddBusy = '1';
    button.disabled = true;
    button.textContent = 'Adding...';

    try {
      var response = await fetch(rootUrl() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }]
        })
      });

      var data = await response.json();
      if (!response.ok) {
        throw new Error(data.description || data.message || 'Could not add item');
      }

      button.textContent = 'Added ✓';

      await refreshNativeCart();
      scheduleSync();
    } catch (error) {
      if (button.isConnected) {
        button.disabled = false;
        button.textContent = originalText;
        button.dataset.abNativeAddBusy = '0';
      }
      console.warn('[CELIA] Complete your order add failed:', error);
    } finally {
      upsellBusy = false;

      window.setTimeout(function () {
        if (button.isConnected) {
          button.disabled = false;
          button.dataset.abNativeAddBusy = '0';
          if (button.textContent === 'Added ✓') button.textContent = originalText;
        }
      }, 1500);
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var button = target && target.closest ? target.closest('.ab-upsell-card__add') : null;
    if (!button) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    addUpsell(button);
  }, true);

  var observer = new MutationObserver(function (mutations) {
    var shouldSync = mutations.some(function (mutation) {
      var target = mutation.target && mutation.target.nodeType === 1
        ? mutation.target
        : mutation.target && mutation.target.parentElement;

      if (!target) return false;
      return Boolean(target.closest && target.closest('#cart-drawer, cart-drawer, [data-cart-drawer]'));
    });

    if (shouldSync) scheduleSync();
  });

  function init() {
    syncAll();
    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
    [250, 900, 1800].forEach(function (delay) {
      window.setTimeout(scheduleSync, delay);
    });
  }

  document.addEventListener('theme:cart:change', scheduleSync);
  document.addEventListener('theme:product:added', scheduleSync);
  document.addEventListener('shopify:section:load', scheduleSync);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
